<template>
  <div
    class="flex justify-center gap-sm rounded-md border border-amber-700 bg-[--amber-50] py-sm px-xs border-thin"
  >
    <font-awesome-icon
      class="text-amber-700"
      icon="fa-regular fa-lightbulb-on"
      size="lg"
    />
    <p class="text-text-secondary type-interface-sm"><slot></slot></p>
  </div>
</template>

<script setup lang="ts">
import { library } from "@fortawesome/fontawesome-svg-core";
import { faLightbulbOn } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faLightbulbOn);
</script>
